<template>
  <button
    id="back_button"
    type="button"
    class="nav-button"
    @click="navigatePrev"
  >
    {{ $t('components.brazil_back_button.text') }}
  </button>
</template>
<script>
import captureRenderBlockingException from '../tracking/helpers/captureRenderBlockingException';

export default {
  props: {
    clickFn: {
      type:     Function,
      required: false,
      default:  null,
    },
  },
  methods: {
    navigatePrev() {
      try {
        this.flash().destroyAll();
        if (this.clickFn !== null) {
          this.clickFn();
        } else {
          this.$router.go(-1);
        }
      } catch (e) {
        captureRenderBlockingException(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  #back_button {
    border: 1px solid grey;
    transition: 0.1s ease-in-out;
    text-transform: uppercase;
    font-weight: bold;
    padding: 1em 2em;
    text-align: center;
    border-radius: 5px;
    &:hover {
      transform: scale(1.02);
      cursor: pointer;
    }
  }
</style>
